import React, { FC } from 'react';
import AltTagCard from '../cards/altTagCard';
import { useTranslate } from '@tolgee/react';

interface Props {
  PLATFORM: string;
  mediaFiles: any;
  mediaAltTags: any[];
  setMediaAltTags: React.Dispatch<React.SetStateAction<any[]>>;
}

const MediaTags: FC<Props> = ({
  PLATFORM,
  mediaFiles,
  mediaAltTags,
  setMediaAltTags
}) => {
  const { t } = useTranslate();
  const updateAltTag = (uuid: string, value: string) => {
    setMediaAltTags((prev) =>
      prev.map((tag) =>
        tag.uuid === uuid ? { ...tag, media_alt_description: value } : tag
      )
    );
  };

  return (
    <div
      style={{ overflowY: 'auto' }}
      className="w-100 h-100 d-flex flex-column gap-2 "
    >
      {mediaAltTags?.length > 0 ? (
        mediaAltTags?.map((item) => (
          <div className="px-3 py-1">
            <AltTagCard item={item} handleChange={updateAltTag} />
          </div>
        ))
      ) : (
        <div className="w-100 h-100 d-flex justify-content-center align-items-center">
          {t('lomavisCreator.mediaAltTags.emptyMedia')}
        </div>
      )}
    </div>
  );
};

export default MediaTags;
